import React, { FC, useEffect, memo } from 'react';

import { ModalProps, ModalTypes } from 'application/providers/ModalProvider';
import { RouterUtils, useNavigate } from 'application/providers/RouterProvider';
import { BILLING_PAGE_PATH, StateParamValues } from 'application/pages/BillingPage';
import AnalyticsService from 'application/services/AnalyticsService';
import { BillingEventNameAMP } from 'application/services/AnalyticsService/ampTypes';
import { PRICE_PLAN_PAGE_PATH } from 'application/consts';
import { useAccountCompanyIsBillingEnabled } from 'application/hooks';

import Button from '@zvuk-b2b/react-uikit/ui/Button';
import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';

import { TEXTS } from './texts';
import PointAddressItem from '../StreamBindSuccessModal/components/PointAddressesList/PointAddressItem';
import { useOnboardingActionContext } from '../useOnboardingActionContext';
import { useOnboardingContext } from '../useOnboardingContext';

import styles from './index.module.scss';
import { SelectPlayerFlowType } from '../types';

const PaymentRequirementModal: FC<ModalProps[ModalTypes.PAYMENT_REQUIREMENT]> = ({ close }) => {
  const { currentPoint, flowType } = useOnboardingContext();
  const { clearCurrentPoint } = useOnboardingActionContext();

  const isBillingEnabled = useAccountCompanyIsBillingEnabled();

  const navigate = useNavigate();

  const billingPagePath = RouterUtils.generatePath(BILLING_PAGE_PATH, { state: StateParamValues.INFO });
  const pricePlanPagePath = RouterUtils.generatePath(PRICE_PLAN_PAGE_PATH);

  useEffect(() => {
    AnalyticsService.event(BillingEventNameAMP.PAYMENT_REQUIREMENT_MODAL_OPEN);
  }, []);

  const onSubmit = () => {
    AnalyticsService.event(BillingEventNameAMP.PAYMENT_REQUIREMENT_MODAL_SUBMIT);
    close();
    navigate(isBillingEnabled ? billingPagePath : pricePlanPagePath, { replace: true });
  };

  const onClose = () => {
    clearCurrentPoint();
    close();
  };

  return (
    <ModalScreen
      title={TEXTS.MODAL_TITLE}
      titlePlacement="left"
      onClose={onClose}
      contentClassName={styles.content}
      actionButtons={[
        <Button
          key="payment_requirement_modal_move_to_billing_button"
          elementId="payment_requirement_modal_move_to_billing_button"
          onClick={onSubmit}>
          {TEXTS.MODAL_BUTTON_SUBMIT}
        </Button>,
      ]}>
      <span className={styles.description}>
        {flowType === SelectPlayerFlowType.BIND_STREAM || flowType === SelectPlayerFlowType.FULL_ONBOARDING
          ? TEXTS.MODAL_DESCRIPTION_STREAM
          : TEXTS.MODAL_DESCRIPTION_DEVICE}
      </span>

      {currentPoint?.id && (
        <PointAddressItem
          id={currentPoint?.id}
          address={currentPoint.address}
        />
      )}
    </ModalScreen>
  );
};

export default memo(PaymentRequirementModal);
